// extracted by mini-css-extract-plugin
export var subtitle = "_cq-2";
export var title = "_cq-0";
export var titleNoWrap = "_cq-1";